import { httpClient } from "../../shared/services/httpClient";

export const getDepositFormParams = (formData: FormData) =>
  httpClient.post("/deposit/initPayment", formData);

export const submitDeposit = ({
  afm,
  depositCode,
  mode,
}: {
  afm: string;
  depositCode: string;
  mode: "certificateApp" | "subscription" | "application" | "violationCase";
}) => {
  const formData = new FormData();
  formData.append("afm", afm);
  formData.append("depositCode", depositCode);
  formData.append("mode", mode);
  return httpClient.post("/deposit/submitDeposit", formData);
};

export const getSuccessParams = () => httpClient.get("/deposit/success");
